// removed by extract-text-webpack-plugin
module.exports = {"linchen-imgwrap":"linchen-imgwrap","full":"full","cover":"cover","discard":"discard"};


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/ImgWrap/index.less
// module id = 899
// module chunks = 367